<template>
  <div class="form">
    <form @submit.prevent class="form__content">
      <IdentityQueueStepCounter />
      <div>
        <h1 class="extra-large-headline">
          {{ $t('WalletAddressVerification.label.headline') }}
        </h1>
        <p class="bodycopy" id="bodyCopy">
          {{ $t('WalletAddressVerification.label.body') }}
        </p>
      </div>

      <!-- <FormInputField
		  v-if="walletAddress"
		  type="text"
		  disabled
		  :label="
			$t('FormInputField.label.walletAddress')
		  "
		  :inputValue="walletAddress"
		/>

		<FormInputField
		  v-if="walletAddressTag"
		  type="text"
		  disabled
		  :label="
			$t('FormInputField.label.walletAddressTag')
		  "
		  :inputValue="walletAddressTag"
		/> -->

      <FormInputField
        type="text"
        :label="$t('FormInputField.label.walletProvider')"
        :placeholder="$t('FormInputField.placeholder.walletProvider')"
        name="declaredWalletProvider"
        :inputValue="form.declaredWalletProvider"
        v-model:declaredWalletProvider="form.declaredWalletProvider"
        autofocus
      />

      <div>
        <p>{{ $t('WalletAddressVerification.ul.list1Header') }}</p>
        <ul class="form__walletAddress-instructions bodycopy">
          <li>{{ $t('WalletAddressVerification.ul.list1a') }}</li>
          <li>{{ $t('WalletAddressVerification.ul.list1b') }}</li>
          <li>{{ $t('WalletAddressVerification.ul.list1c') }}</li>
        </ul>

        <p>{{ $t('WalletAddressVerification.ul.list2Header') }}</p>
        <ul class="form__walletAddress-instructions bodycopy">
          <li>{{ $t('WalletAddressVerification.ul.list2a') }}</li>
          <li>{{ $t('WalletAddressVerification.ul.list2b') }}</li>
          <li>{{ $t('WalletAddressVerification.ul.list2c') }}</li>

          <li
            v-html="
              $t('WalletAddressVerification.ul.list2d', {
                insertLink: `<a
				target='_blank'
				href='https://support.banxa.com/en/support/solutions/articles/44002483742-verifying-your-wallet-address'>${$t(
          'WalletAddressVerification.ul.here',
                )}</a>`,
              })
            "
          />
        </ul>
      </div>

      <div class="walletAddress-content-container">
        <img
          class="walletAddress-image"
          src="@/assets/images/identity/walletAddressVerificationSample.png"
        />
      </div>

      <FileUploadField
        name="walletDocument"
        :label="$t('FileUploadField.label.walletImage')"
        :placeholder="$t('FileUploadField.placeholder.selectOrDrag')"
        iconType="VerificationCircle"
        :errors="form.walletDocumentErrors"
        @updateFile="updateFiles"
      />

      <ButtonBase
        :isDisabled="formHasErrors || globalStore.getIsFormLoading"
        :isLoading="globalStore.getIsFormLoading"
        @onButtonClick="handleFormSubmit"
      >
        {{ $t('ButtonBase.label.walletImage') }}
      </ButtonBase>
    </form>

    <IdentityQueueNext />
  </div>
</template>

<script setup>
import { reactive, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';

import { useGlobalStore } from '@/stores/globalStore';
import { useIdentityQueueStore } from '@/stores/identityQueueStore';
import { useOrderFormStore } from '@/stores/forms/orderFormStore';

import useApiHelpers from '@/composables/api/helpers';
import useCustomerActions from '@/composables/api/useCustomerActions';
import useFormValidation from '@/composables/validations/useFormValidation';
import useLocalStorage from '@/composables/storage/useLocalStorage';

import FileUploadField from '@/components/ui/inputs/FileUploadField.vue';
import ButtonBase from '@/components/ui/buttons/ButtonBase.vue';
import FormInputField from '@/components/ui/inputs/FormInputField.vue';
import IdentityQueueNext from '@/components/layout/progress/IdentityQueueNext.vue';
import IdentityQueueStepCounter from '@/components/layout/progress/IdentityQueueStepCounter.vue';

const router = useRouter();
const route = useRoute();
const globalStore = useGlobalStore();
const identityQueueStore = useIdentityQueueStore();

const { validateFileInput } = useFormValidation();
const { postRequest } = useApiHelpers();
const { fetchCustomerId } = useCustomerActions();
// const { getFromLocalStorage } = useLocalStorage();
// const { getActiveMode } = useOrderFormStore();

const form = reactive({
  walletAddressDocument: [],
  walletDocumentErrors: '',
  declaredWalletProvider: '',
});

const updateFiles = (file) => {
  const fileValidationErrors = validateFileInput('walletAddressDocument', file);
  form.walletAddressDocument = file;
  form.walletAddressDocumentErrors = fileValidationErrors;
};

const handleFormSubmit = async () => {
  const custId = await fetchCustomerId();
  const formData = new FormData();
  const docSubType = 'wallet';

  formData.set('documentFile', form.walletAddressDocument);
  formData.set('documentSubType', docSubType);
  formData.set('documentReference', custId);
  formData.set('declaredWalletProvider', form.declaredWalletProvider);

  globalStore.setIsFormLoading(true);
  postRequest('documents/wallet', formData, () => {
    identityQueueStore.updateToNextRoute();
    identityQueueStore.fetchNextIdentityRoute(route).then(async (nextRoute) => {
      router.push(nextRoute);
    });
  });
};

// const walletAddress = computed(() => getFromLocalStorage(
//     `${getActiveMode.toLowerCase()}Order.walletAddress.value`,
//   ));

// const walletAddressTag = computed(() => getFromLocalStorage(
//     `${getActiveMode.toLowerCase()}Order.walletAddressTag.value`,
//   ));

const formHasErrors = computed(() => {
  const anyErrors = form.walletAddressDocumentErrors !== '';
  const anyFieldsEmpty = form.walletAddressDocument.length === 0 || !form.declaredWalletProvider;

  return anyErrors || anyFieldsEmpty;
});
</script>

<style lang="scss" scoped>
.form__content {
  padding-bottom: 3rem;
  max-width: 54rem;
  padding: 0 2rem;

  @include breakpoint($min-m) {
    padding-inline: 0;
  }

  .bodycopy {
    margin-bottom: 1rem;
    @include breakpoint($min-m) {
      margin-bottom: 1.5rem;
    }
  }
  .form__walletAddress-instructions {
    list-style: unset;
    padding-inline: 1.5rem;

    li {
      font-size: $font-body;
      line-height: 1.5;
    }
  }
}

.walletAddress-image {
  display: flex;
  max-width: 90%;
  height: 403px;
  position: relative;
  margin: 0 auto;

  @include breakpoint($max-sm) {
    height: 250px;
  }
}
.walletAddress-content-container {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: end;
  width: 100%;
  font-size: 10px;
  margin-bottom: 10px;
  color: $black;

  @include breakpoint($max-sm) {
    font-size: 7px;
    min-height: unset;
  }

  .walletAddress-content {
    width: 50%;
    text-align: center;
    position: absolute;

    p {
      margin: 0;
      max-width: 80px;
      color: $black;
      @include breakpoint($max-sm) {
        font-size: 8px;
      }
    }
    &.left {
      left: 82px;

      @include breakpoint($max-sm) {
        left: 40px;
      }
    }
    &.right {
      right: -33px;
      @include breakpoint($max-sm) {
        right: -5px;
      }
    }
  }
}
</style>
